import React from 'react'
import Podsumowanie from '../../common/pages/Podsumowanie.jsx'

const S1_Podsumowanie = (props) => {
    return (
        <Podsumowanie data={{...props, wzor: 's1'}}/>
    )
}

export default S1_Podsumowanie

